(function () {
  "use strict";

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function initPicker(node) {
    var handle = node.getAttribute("data-product-handle");
    var optionName = node.getAttribute("data-option-name");
    var variantOptions = handle
      ? document.querySelector('variant-options[data-product-handle="' + escapeSelector(handle) + '"]')
      : document.querySelector("variant-options");

    if (!variantOptions || !optionName) return;

    variantOptions.classList.add("ama-shade-picker-enabled");

    // Gallery behaviour depends on whether each shade has its own product photo yet.
    // data-gallery-switch="false" (swatch is still the variant image): keep the big
    // gallery static — neutralise the theme's swap-to-variant-image, so the gallery
    // doesn't jump to the rectangular swatch. data-gallery-switch="true" (each variant
    // image is now the shade's PRODUCT photo and the swatch lives in amalife.swatch):
    // let the native swap run, so selecting a shade shows that shade's product photo.
    if (node.getAttribute("data-gallery-switch") !== "true") {
      try {
        var voProto = variantOptions.constructor && variantOptions.constructor.prototype;
        if (voProto && typeof voProto.updateGallery === "function" && !voProto.__amaNoGallerySwap) {
          voProto.__amaNoGallerySwap = true;
          voProto.updateGallery = function () {};
        }
      } catch (e) {}
      variantOptions.updateGallery = function () {};
    }

    function syncByVariant(variantId, caption) {
      var cards = node.querySelectorAll("[data-shade-card]");
      cards.forEach(function (card) {
        var isActive = String(card.getAttribute("data-variant-id")) === String(variantId);
        card.classList.toggle("is-selected", isActive);
        card.setAttribute("aria-checked", isActive ? "true" : "false");
      });

      var valueEl = node.querySelector("[data-shade-value]");
      if (valueEl && caption) valueEl.textContent = caption;
    }

    node.querySelectorAll("[data-shade-card]").forEach(function (card) {
      card.addEventListener("click", function () {
        var optionValue = card.getAttribute("data-option-value");
        if (!optionValue) return;

        var input = variantOptions.querySelector(
          'input[name="' + escapeSelector(optionName) + '"][value="' + escapeSelector(optionValue) + '"]'
        );

        if (!input) return;
        if (!input.checked) input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var variant = evt && evt.data && evt.data.variant;
        if (!variant) return;

        var active = node.querySelector('[data-shade-card][data-variant-id="' + variant.id + '"]');
        if (!active) return;

        syncByVariant(variant.id, active.getAttribute("data-caption"));
      });
    }
  }

  function init() {
    document.querySelectorAll("[data-ama-shade-picker]").forEach(initPicker);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
